import React from 'react';
import cloneDeep from 'lodash.clonedeep';

import t from '../../../labels/labelling-utils';
import { IMatchScoreEvent, OWN } from '../../../typings/match-formations';
import { IPlayer } from '../../../typings/player';
import { isEmptyArray } from '../../../utils/array';
import IconFormation from '../../atoms/icons/icon-formation';
import CourtesyMessage from '../../organisms/courtesy-message/courtesy-message';

import { IMatchFormationsDataTeam } from './match-formations';

/**
 * Function to validate startingLineup (starting players list)
 * @param startingLineup a starting players list
 */
export const isValidStartingLineUp = (startingLineup: Array<IPlayer> | undefined) =>
  Boolean(startingLineup && startingLineup.length);

/**
 * Background Icon for Formation Courtesy Message
 */
const backgroundIconFormation = () => <IconFormation size="xxlarge" color="medium-light" />;

/**
 * Utility function to get Courtesy Messages
 */
export const getCourtesyMessage = () => (
  <CourtesyMessage text={t('match.formations.errorMessage')} backgroundIcon={backgroundIconFormation()} />
);

export const exchangeOwnGoals = (lineups: IMatchFormationsDataTeam): IMatchFormationsDataTeam => {
  // Actually AUTOGOALS are passed in the "wrong " team
  // As if the AUTOGOAL SCORER is in the TEAM which actually EARNS the GOAL
  // But the ID of the AUTOGOAL SCORER is in the OPPOSITE TEAM!
  // So the ID of the PLAYER is NOT FOUND when generating the AUTOSCORE red icon
  // WORKAROUND: MOVE the ID of the AUTOGOAL SCORER from one TEAM to the OTHER!
  // This function MUTATES passed data (but returns a DEEP COPY)
  if (isEmptyArray(lineups.home.goals) && isEmptyArray(lineups.away.goals)) {
    return lineups;
  }

  // const clonedLineups: IMatchFormationsDataTeam = cloneDeep(lineups); // FIXME: Use LODASH-ES DEEPCLONE to avoid MUTATION of original LINEUPS object
  const clonedLineups: IMatchFormationsDataTeam = cloneDeep(lineups);
  const homeAutogoals: IMatchScoreEvent[] | undefined =
    /* istanbul ignore next: unsupported optional chaining */ clonedLineups.home.goals?.filter(
      (goal) => goal.type === OWN
    );
  const awayAutogoals: IMatchScoreEvent[] | undefined =
    /* istanbul ignore next: unsupported optional chaining */ clonedLineups.away.goals?.filter(
      (goal) => goal.type === OWN
    );

  if (homeAutogoals && homeAutogoals.length > 0) {
    homeAutogoals.forEach((goal) =>
      /* istanbul ignore next: unsupported optional chaining */ clonedLineups.home.goals?.splice(
        clonedLineups.home.goals?.indexOf(goal),
        1
      )
    ); // REMOVE found AUTOGOALS from THIS team
    /* istanbul ignore next: unsupported optional chaining */ clonedLineups.away.goals?.push(...homeAutogoals); // ADD found AUTOGOALS to the OTHER team
  }

  if (awayAutogoals && awayAutogoals.length > 0) {
    awayAutogoals.forEach((goal) =>
      /* istanbul ignore next: unsupported optional chaining */ clonedLineups.away.goals?.splice(
        clonedLineups.away.goals?.indexOf(goal),
        1
      )
    ); // REMOVE found AUTOGOALS from THIS team
    /* istanbul ignore next: unsupported optional chaining */ clonedLineups.home.goals?.push(...awayAutogoals); // ADD found AUTOGOALS to the OTHER team
  }

  return clonedLineups;
};
